import moment from 'moment';
import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheBaseServerGet, callTheBaseServerPost } from './helpers/axiosHelper';

import { initPaytmJsCheckout, loadJsCheckoutLibrary } from './helpers/paytmHelper';
import { addDNoneClass, btnLoading, byId, insertDataToElementUsingClassName } from './helpers/utility';



const queryString = require('query-string');

authHelper.validate();

// checking query params for transition result alert

const parsedQuery = queryString.parse(location.search);


if (parsedQuery.transactionStatus) {
    if (parsedQuery.transactionStatus === 'SUCCESS') {
        Swal.fire({
            icon: 'success',
            title: 'Transaction Success 🥰',
            text: 'Credits Successfully Deposited in Your Wallet',

        });
    }
    if (parsedQuery.transactionStatus === 'PENDING') {
        Swal.fire({
            icon: 'info',
            title: 'Transaction Still Pending 😫',
            text: parsedQuery.transactionResponse,

        });
    }
    if (parsedQuery.transactionStatus === 'FAILURE') {
        Swal.fire({
            icon: 'error',
            title: 'Transaction Failed 😢',
            text: parsedQuery.transactionResponse,

        });
    }
}


insertDataToElementUsingClassName('total-credits-text-here', parseFloat(getMtaApBasicData().depositCredit + getMtaApBasicData().bonusCredit).toFixed(2) );
insertDataToElementUsingClassName('deposit-credits-text-here', getMtaApBasicData().depositCredit);
insertDataToElementUsingClassName('bonus-credits-text-here', getMtaApBasicData().bonusCredit);
// refreshing wallet data 
refreshApBasicData().then(() => {
    insertDataToElementUsingClassName('total-credits-text-here', parseFloat(getMtaApBasicData().depositCredit + getMtaApBasicData().bonusCredit).toFixed(2) );
    insertDataToElementUsingClassName('deposit-credits-text-here', getMtaApBasicData().depositCredit);
    insertDataToElementUsingClassName('bonus-credits-text-here', getMtaApBasicData().bonusCredit);
});



// buy more code 

const creditBuyQuantityInput = byId('creditBuyQuantityInput');
const creditBuyTotalAmountInput = byId('creditBuyTotalAmountInput');
const buyMoreSubmitBtn = byId('buyMoreSubmitBtn');

creditBuyQuantityInput.addEventListener('input', function (e) {

    const value = (e.target.value);
    if (value < 1) {

        creditBuyTotalAmountInput.value = 1;

          addDNoneClass(buyMoreSubmitBtn, true);
    }else{
        creditBuyTotalAmountInput.value = value;

        addDNoneClass(buyMoreSubmitBtn, false);
    }

    


});



const buyMoreInitBtn = byId('buyMoreInitBtn');
const buyMoreCancelBtn = byId('buyMoreCancelBtn');
const buyMoreCardDivElement = byId('buyMoreCardDivElement');
buyMoreInitBtn.addEventListener('click', () => { addDNoneClass(buyMoreCardDivElement, false); });
buyMoreCancelBtn.addEventListener('click', () => { addDNoneClass(buyMoreCardDivElement, true); });




const initTransactionFun = () => {

    btnLoading(buyMoreSubmitBtn,'',true);
    const formData = {

        txnAmount: parseFloat(creditBuyTotalAmountInput.value).toFixed(2),
        clientLocationUrl: window.location.origin + window.location.pathname


    };
    // paytm code below 
  
    callTheBaseServerPost('/paytm/init', { data: formData }).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);
            const { orderId, token, txnAmount } = res;


            const txnAmountValue = txnAmount.value;
            loadJsCheckoutLibrary();
            initPaytmJsCheckout(orderId, token, txnAmountValue);

        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

buyMoreSubmitBtn.addEventListener('click', initTransactionFun);


// redeem code below 
const redeemInitBtn =byId('redeemInitBtn');
const redeemCancelBtn =byId('redeemCancelBtn');
const redeemCardDivElement =byId('redeemCardDivElement');
console.log(redeemInitBtn);
redeemInitBtn.addEventListener('click', () => { addDNoneClass(redeemCardDivElement, false); });
redeemCancelBtn.addEventListener('click', () => { addDNoneClass(redeemCardDivElement, true); });

const creditRedeemMethodNameSelectInput = byId('creditRedeemMethodNameSelectInput');
const creditRedeemMethodIdInputLabelElement = byId('creditRedeemMethodIdInputLabelElement'); 

const creditRedeemMethodSelectFun = () =>{
    if(creditRedeemMethodNameSelectInput.value ==='UPI'){
        creditRedeemMethodIdInputLabelElement.innerText='UPI ID (Ex: 983487xxxx@upi)';
    }else{
        creditRedeemMethodIdInputLabelElement.innerText=`${creditRedeemMethodNameSelectInput.value} Wallet Number (Ex: 9834xxxx06)`;
    }
};
creditRedeemMethodSelectFun();
creditRedeemMethodNameSelectInput.addEventListener('input', creditRedeemMethodSelectFun);


const creditRedeemQuantityInput = byId('creditRedeemQuantityInput');

const creditRedeemChargeInput = byId('creditRedeemChargeInput');
const creditRedeemFinalAmountInput = byId('creditRedeemFinalAmountInput');
const redeemSubmitBtn = byId('redeemSubmitBtn');

const redeemCalculationsFun = () =>{
    

        const value = creditRedeemQuantityInput.value;
        if (value < 6) {
    
    
            creditRedeemFinalAmountInput.value = creditRedeemChargeInput.value  =  0;
           
            addDNoneClass(redeemSubmitBtn,true);
        }else{
            addDNoneClass(redeemSubmitBtn,false);
    
            if(value < 100){
    
                creditRedeemChargeInput.value= 5;
                creditRedeemFinalAmountInput.value = value- creditRedeemChargeInput.value;
            }else{
                creditRedeemChargeInput.value= (5 * value)/100;
                creditRedeemFinalAmountInput.value = value- creditRedeemChargeInput.value;
            }
        }
    
      
    
    
    
};
redeemCalculationsFun();

creditRedeemQuantityInput.addEventListener('input',redeemCalculationsFun );

const creditRedeemMethodIdInput =byId('creditRedeemMethodIdInput');

const redeemRequestFun = () =>{
    const formData = {
        methodName:creditRedeemMethodNameSelectInput.value,
        methodId:creditRedeemMethodIdInput.value,
        amount:creditRedeemQuantityInput.value,
    };
    callTheBaseServerPost(`/wallet/redeemRequest`,{ data: formData }).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;




     

        if (res.status === 'success') {
            console.log(res);
            Swal.fire({
                icon: 'success',
                title: 'Redeem Requested Success',
                text: 'Redeemed Funds will be transferred your (Bank /Wallet) in Next 24 to 48 Hr ',
    
            });

            setTimeout(()=>{location.href=window.location.origin + window.location.pathname;}, 3000);
           


        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

 redeemSubmitBtn.addEventListener('click',redeemRequestFun );


// get wallet history

let skip = 0;
const walletHistoryTableLoadMoreDivElement = byId('walletHistoryTableLoadMoreDivElement');


const fetchWalletHistory = () => {
    addDNoneClass(walletHistoryTableLoadMoreDivElement, true);

    callTheBaseServerGet(`/wallet/walletHistory/${skip}/10`).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;




        const walletHistoryTableBodyElement = byId('walletHistoryTableBodyElement');
        const walletHistoryTableNoDataRowElement = byId('walletHistoryTableNoDataRowElement');

        if (res.status === 'success') {
            console.log(res);

            const walletHistoryData = res.walletHistoryData;
            let i = 0;
            skip += 10;




            if (walletHistoryData.length > 0) {
                addDNoneClass(walletHistoryTableLoadMoreDivElement, false);
                addDNoneClass(walletHistoryTableNoDataRowElement, true);


                while (i < walletHistoryData.length) {

                    const date = moment(walletHistoryData[i].createdAt * 1000).format('DD/MM/YYYY');
                    const time = moment(walletHistoryData[i].createdAt * 1000).format('LT');

                    walletHistoryTableBodyElement.innerHTML += `
                    <tr>
                       
                        <td>${walletHistoryData[i].sn}</td>
                    
                        <td>${walletHistoryData[i].walletType}</td>
                        <td>${walletHistoryData[i].transactionType}</td>
                        <td>${parseFloat(walletHistoryData[i].amount).toFixed(2)} Credits</td>
                        <td>${parseFloat(walletHistoryData[i].closingBalance).toFixed(2)} Credits</td>
                        <td>${date} <br> ${time}</td>
                        <td>${walletHistoryData[i].comment}</td>
                    </tr>
                    `;
                    i++;
                }
            }

            if (walletHistoryData.length === 0) {

               
              

                if(skip ===0){
                    walletHistoryTableNoDataRowElement.innerHTML = `
                    <th class='text-center' colspan='6'>No Wallet Transactions Found 😥</th> 
                    `;
                }else{
                    addDNoneClass(walletHistoryTableLoadMoreDivElement, true);
                }
            }else{
                addDNoneClass(walletHistoryTableLoadMoreDivElement, false);
            }



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

fetchWalletHistory();




walletHistoryTableLoadMoreDivElement.addEventListener('click', fetchWalletHistory);
